import MasterShopSpecifyLayout from './MasterShopSpecifyLayout';

export default MasterShopSpecifyLayout;
